export const defaultTagColors = [
  {
    "id": 1,
    "name": "Lavender",
    "code": "#C2C6F4",
    "textCode": "#000757",
  },
  {
    "id": 2,
    "name": "Mauve",
    "code": "#E4C2F4",
    "textCode": "#3A0057",
  },
  {
    "id": 3,
    "name": "Orchid",
    "code": "#F4C2DF",
    "textCode": "#570033",
  },
  {
    "id": 4,
    "name": "Mint",
    "code": "#C2F4E8",
    "textCode": "#005741",
  },
  {
    "id": 5,
    "name": "Yellow",
    "code": "#F4F4C2",
    "textCode": "#575700",
  },
  {
    "id": 6,
    "name": "Peach",
    "code": "#F4DFC2",
    "textCode": "#573300",
  },
  {
    "id": 7,
    "name": "Rose",
    "code": "#F4C2C2",
    "textCode": "#570000",
  },
  {
    "id": 8,
    "name": "Pastel",
    "code": "#CBF4C2",
    "textCode": "#0E5700",
  },
  {
    "id": 9,
    "name": "Sky",
    "code": "#C2DFF4",
    "textCode": "#003357",
  },
  {
    "id": 10,
    "name": "Periwinkle",
    "code": "#D3C2F4",
    "textCode": "#1D0057",
  },
  {
    "id": 11,
    "name": "Lime",
    "code": "#E8F4C2",
    "textCode": "#415700",
  }
];
